import { createContext, useContext } from 'react';

type ContractsContextType = {
  columnHeadings: string[];
  hiddenColumns: number[];
  setHiddenColumns: (hiddenColumns: number[]) => void;
  modifyFilters: (string: any, object: any) => void;
  filters: object;
  topAdvertisersActive: boolean;
  toggleTopAdvertisers: () => void;
};

export const ContractsContext = createContext<ContractsContextType | undefined>(undefined);

export const useContractsContext = (): ContractsContextType => useContext(ContractsContext);
